<template>
	<div class="cpage" style=" overflow: auto;">

		<div style=" border: 2px solid #c5e3fd; background-color: #fff;">
			<el-form :model="stuForm" inline ref="adminUserInfo" label-width="100px">
				<div
					style="background-color: #f7f8fc; padding: 20px; font-size: 12px; font-weight: bold; margin-bottom: 10px;">
					<span class="rowlabel"></span>基本信息
				</div>
				<div style="max-width: 1000px;padding-left: 20px;">

					<el-row :gutter="20" style=" ">
						<el-col :span="12">
							<el-form-item label="考生姓名" prop="考生姓名">
								<span slot="label">
									考生姓名<span style="color: orangered;">*</span>
								</span>
								<el-input type="text" v-model="stuForm.stu_name" style="width: 300px;"
									placeholder="考生姓名" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="身份证号" prop="身份证号">
								<span slot="label">
									身份证号<span style="color: orangered;">*</span>
								</span>
								<el-input type="text" v-model="stuForm.identity_card" style="width: 300px;"
									placeholder="身份证号" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">

						<el-col :span="12">
							<el-form-item label="性别" prop="性别">
								<span slot="label">
									性别<span style="color: orangered;">*</span>
								</span>
								<el-select v-model="stuForm.gender" style="width: 300px;">
									<el-option label="男" :value="1"></el-option>
									<el-option label="女" :value="2"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="民族" prop="民族">
								<span slot="label">
									民族<span style="color: orangered;">*</span>
								</span>
								<el-select v-model="stuForm.minzu" style="width: 300px;">
									<el-option v-for="(item,index) in minzuList" :key="index" :value="item"
										:label="item">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="户口性质" prop="户口性质">
								<span slot="label">
									户口性质<span style="color: orangered;">*</span>
								</span>
								<el-select v-model="stuForm.hkxz" style="width: 300px;">
									<el-option label="非农业户口" value="非农业户口"></el-option>
									<el-option label="农业户口" value="农业户口"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="户口所在地" prop="户口所在地">
								<span slot="label">
									户口所在地<span style="color: orangered;">*</span>
								</span>
								<el-cascader ref="hukou" v-model="stuForm.hukou_code" style="width: 300px;"
									@change="selectHukou" :props="treeProps" clearable :options="hukouData"
									placeholder="请选择户口所在地"></el-cascader>
							</el-form-item>
						</el-col>


						<el-col :span="12">
							<el-form-item label="学校所在地" prop="archive">
								<span slot="label">
									学校所在地<span style="color: orangered;">*</span>
								</span>
								<el-cascader ref="graduate_city" v-model="stuForm.graduate_dist_code"
									style="width:300px;" @change="selectGraduateCity" :props="treeProps" clearable
									:options="areas" placeholder="请选择毕业地区"></el-cascader>


							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所在学校" prop="exam_num">
								<span slot="label">
									所在学校<span style="color: orangered;">*</span>
								</span>
								<el-select filterable remote placeholder="请输入关键词搜索或直接输入学校名称" clearable
									:remote-method="searchSchool" v-model="stuForm.graduate_schname"
									style="width: 300px;">
									<el-option v-for="(item,idx) in AllSchoolList" :key="idx"
										:label="item.graduate_schname" :value="item.graduate_schname">
									</el-option>
								</el-select>

							</el-form-item>
						</el-col>
					</el-row>


				</div>

				<div
					style="background-color: #f7f8fc; padding: 20px; font-size: 12px; font-weight: bold; margin-bottom: 10px;">
					<span class="rowlabel"></span>报考信息
				</div>
				<div style="max-width: 1000px;padding-left: 20px;">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="考生来源" prop="archive">
								<span slot="label">
									考生来源<span style="color: orangered;">*</span>
								</span>
								<el-select v-model="stuForm.ly_type" placeholder="请选择" style="width: 93%">
									<el-option :value="1" label="应届生（本年度6月份毕业）"></el-option>
									<el-option :value="2" label="其他"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="收件地址" prop="exam_num">
								<span slot="label">
									收件地址<span style="color: orangered;">*</span>
								</span>
								<el-input type="text" v-model="stuForm.jtzz" style="width: 300px;"
									placeholder="请输入完整收件地址" />
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="收件人" prop="archive">
								<span slot="label">
									收件人<span style="color: orangered;">*</span>
								</span>
								<el-input type="text" v-model="stuForm.jhr1name" style="width: 300px;"
									placeholder="请输入收件人姓名" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="报考专业" prop="exam_num">
								<span slot="label">
									报考专业<span style="color: orangered;">*</span>
								</span>
								<el-input @focus="majorShow=true" placeholder="请选择专业" suffix-icon="el-icon-search"
									v-model="stuForm.major_name" style="width: 300px;">
								</el-input>



							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="学制" prop="archive">
								<span slot="label">
									学制<span style="color: orangered;">*</span>
								</span>
								<el-input type="text" v-model="stuForm.xuezhi" readonly="" style="width: 300px;"
									placeholder="请先选择专业" />
							</el-form-item>
						</el-col>

					</el-row>
				</div>

				<div
					style="background-color: #f7f8fc; padding: 20px; font-size: 12px; font-weight: bold; margin-bottom: 10px;">
					<span class="rowlabel"></span>附件信息
				</div>
				<div style="max-width: 1000px;padding-left: 20px;">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="户口本或身份证上传" prop="archive">
								<span slot="label">
									<div style="line-height: 20px;">
										身份证或<br>户口本上传<span style="color: orangered;">*</span>
									</div>

								</span>
								<el-upload accept=".jpg,.jpeg,.png" action=""
									style="width: 300px; margin: 0 auto; padding: 10px;" :http-request="uploadOss"
									:on-success="uploadAttch" :show-file-list="false" name="image">
									<div @click="setImageType('identity_card1')">


										<img :src="'./images/zhengjian.jpg'" style="width: 100%;"
											v-if="!otherjson.identity_card1" />
										<img v-else :src="otherjson.identity_card1" style="width: 100%;">
										<div
											style="text-align: center; padding-top:20px ; font-size: 12px; color: #999999;">
											上传户口本或身份证
										</div>
									</div>
								</el-upload>


							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="证件照上传" prop="exam_num">
								<span slot="label">
									证件照上传<span style="color: orangered;">*</span>
								</span>

								<el-upload accept=".jpg,.jpeg,.png" action=""
									style="width: 300px; margin: 0 auto; padding: 10px;" :http-request="uploadOss"
									:on-success="uploadAttch" :show-file-list="false" name="image">
									<div @click="setImageType('dzzj')">
										<img :src="'./images/id_card.jpg'" style="width: 100%;"
											v-if="!otherjson.dzzj" />
										<img v-else :src="otherjson.dzzj" style="width: 100%;">
										<div
											style="text-align: center; padding-top:20px ; font-size: 12px; color: #999999; line-height: 20px;">
											上传证件照（请上传纯色背景的免冠上半身照片，<br>请勿上传生活照！）
										</div>
									</div>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="学历证明" prop="exam_num">
								<span slot="label">
									学历证明<span style="color: orangered;">*</span>
								</span>
								<el-upload accept=".jpg,.jpeg,.png" action=""
									style="width: 300px; margin: 0 auto; padding: 10px;" :http-request="uploadOss"
									:on-success="uploadAttch" :show-file-list="false" name="image">
									<div @click="setImageType('dzzj')">
										<img :src="'./images/xueli.jpg'" style="width: 100%;" v-if="!otherjson.score" />
										<img v-else :src="otherjson.score" style="width: 100%;">
										<div
											style="text-align: center; padding-top:20px ; font-size: 12px; color: #999999;">
											上传学历证明
										</div>
									</div>
								</el-upload>
							</el-form-item>
						</el-col>


					</el-row>
				</div>
				<div style="padding: 100px; text-align: right;">
					<el-button type="primary" icon="el-icon-check" @click="saveStu">提交报名信息</el-button>
				</div>
			</el-form>
		</div>

		<majors v-if="majorShow"></majors>
		<CropperImage @getImage="getImage" v-if="showClip" :ourl="imgoldurl"></CropperImage>
	</div>
</template>
<script>
	import area from "../../../utils/arae_value.js"
	import majors from './majors.vue'
	import CropperImage from '../../com/CropperImage'
	export default {
		name: 'Form',
		components: {
			majors,
			CropperImage
		},
		data() {
			return {
				majorShow: false,
				imgname: "",
				showClip: false,
				imgoldurl: "",
				treeProps: {
					children: 'children',
					label: 'label',
					value: 'value',
					emitPath: false,
				},
				hukouData: [],
				areas: [],
				stuForm: {
					ly_type: "",
					stu_name: "",
					archive: "",
					identity_card: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					volunteerTxt: "",
					oldname: '',
					exam_num: '',
					remark: "",
					jhr1name: "",
					jhr1phone: "",
					jhr2name: "",
					jhr2phone: "",
					minzu: "",
					zzmm: "",
					jiguan: "",
					hkszd: "",
					hkszdpcs: "",
					hkxz: "",
					jzdtype: "",
					jtzz: "",
					hukou_code: "",
					xuezhi: ""


				},
				otherjson: {
					identity_card1: "",
					identity_card2: "",
					hkb: "",
					zkz: "",
					score: "",
					jiaofei: "",
					height: "",
					weight: "",
					size: "",
					remark: "",
					shoes: "",
					zoudu: "",
					dzzj: ""
				},
				AllSchoolList: [],
				minzuList: "汉族、蒙古族、回族、藏族、维吾尔族、苗族、彝族、壮族、布依族、朝鲜族、满族、侗族、瑶族、白族、土家族、哈尼族、哈萨克族、傣族、黎族、僳僳族、佤族、畲族、高山族、拉祜族、水族、东乡族、纳西族、景颇族、柯尔克孜族、土族、达斡尔族、仫佬族、羌族、布朗族、撒拉族、毛南族、仡佬族、锡伯族、阿昌族、普米族、塔吉克族、怒族、乌孜别克族、俄罗斯族、鄂温克族、德昂族、保安族、裕固族、京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、门巴族、珞巴族、基诺族",

			}
		},
		mounted() {
			this.minzuList = this.minzuList.split("、")
			let hkdata = JSON.parse(JSON.stringify(area))
			for (let p of hkdata) {
				for (let c of p.children) {
					delete c.children
				}
			}
			this.hukouData = hkdata
			this.areas = area
			this.getBKinfo()
			
			
		},
		methods: {
			loadScript(url, callback) {
				var script = document.createElement("script");
				script.type = "text/javascript";
				if(script.readyState) { //IE
					script.onreadystatechange = function() {
						if(script.readyState == "loaded" ||
							script.readyState == "complete") {
							script.onreadystatechange = null;
							callback();
						}
					};
				} else { //Others: Firefox, Safari, Chrome, and Opera
					script.onload = function() {
						callback();
					};
				}
				script.onerror = function(e) {}
				script.src = url;
				window.document.body.appendChild(script);
			},
			getBKinfo() {
				this.$http.post("/api/app_stuinfo", {
					pmid: window.pmid,
					phone: sessionStorage.getItem("phone")
				}).then(res => {
					if (res.data) {
						this.$router.push("/bkview")
					}
				})
			},
			selectHukou(e) {
				this.stuForm.hkszd = (this.$refs['hukou'].getCheckedNodes()[0].pathLabels.join(","))
			},
			selectGraduateCity(e) {
				this.stuForm.graduate_sch_city = (this.$refs['graduate_city'].getCheckedNodes()[0].pathLabels.join(","))
			},
			searchSchool(e) {

				this.$http.post("/api/h5_schools", {
					school: e
				}).then(res => {

					this.AllSchoolList = [{
						graduate_schname: e
					}].concat(res.data)
					this.stuForm.graduate_schname = e
				})
			},
			closeMajor(item) {

				this.majorShow = false
				if (item) {
					this.stuForm.major_id = item.id;
					this.stuForm.major_name = "(" + item.item_num + ")" + item.title;
					this.stuForm.xuezhi = item.item_desc


				}


			},
			setImageType(e) {
				this.imgname = e
				console.log(this.imgname)
			},
			uploadAttch(e) {
				if (this.imgname == "dzzj") {
					
						
					this.$http.post("/api/get_zjz", {
						url:e.src.split("?")[0]+"?x-oss-process=image/resize,limit_0,w_800"
					}).then(res => {
						this.otherjson[this.imgname] = res.data.url
					})	
					
				} else {
					this.otherjson[this.imgname] = e.src
				}

			},
			getImage(e) {

				this.otherjson.dzzj = e
				this.showClip = false
			},
			saveStu() {
				// if (this.AreaScore > this.stuForm.exam_score || !this.stuForm.exam_score) {
				// 	Toast('低于' + this.AreaScore + "分数线无法登记");
				// 	return
				// }
				if (!this.stuForm.stu_name) {
					this.$message.error('请输入姓名');
					return
				}
				if (!this.stuForm.identity_card) {
					this.$message.error('请输入身份证号');
					return
				} else {
					var myreg =
						/(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
					if (!myreg.test(this.stuForm.identity_card)) {
						this.$message.error('请输入正确的身份证号');
						return
					}
				}
				this.getBirthdayFromIdCard(this.stuForm.identity_card)

				if (!this.stuForm.gender) {
					this.$message.error('请选择性别');
					return
				}
				if (!this.stuForm.phone) {
					this.$message.error('请输入手机号');
					return
				} else {
					var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
					if (!myreg.test(this.stuForm.phone)) {
						this.$message.error('请输入正确的手机号');
						return
					}
				}
				if (!this.stuForm.minzu) {
					this.$message.error('请选择民族');
					return
				}

				if (!this.stuForm.hkxz) {
					this.$message.error('请选择户口性质');
					return
				}
				if (!this.stuForm.hkszd) {
					Toast('请选择户口所在地');
					return
				}
				// if (!this.stuForm.exam_num) {
				// 	Toast('请输入准考证号');
				// 	return
				// }
				if (!this.stuForm.major_id) {
					this.$message.error('请选择报考专业');
					return
				}
				if (this.stuForm.volunteer === '') {
					this.stuForm.volunteer = 0
				}
				if (!this.stuForm.graduate_sch_city) {
					this.$message.error('请选择地区');
					return
				}
				if (!this.stuForm.graduate_schname) {
					this.$message.error('请选择或输入学校名称');
					return
				}

				if (!this.stuForm.jtzz) {
					this.$message.error('请输入收件地址');
					return
				}
				if (!this.stuForm.jhr1name) {
					this.$message.error('请输入收件人');
					return
				}



				if (this.otherjson.identity_card1) {

				} else {
					this.$message.error('请上传身份证或户口本照片');
					return
				}

				if (!this.otherjson.score) {
					this.$message.error('请上传考试分数条');
					return
				}
				if (!this.otherjson.dzzj) {
					this.$message.error('请上传电子证件照照片');
					return
				}





				this.stuForm.pmid = window.pmid
				this.stuForm.openid = this.openid
				this.stuForm.stu_from_type = 1
				//选择学校后**

				this.stuForm.otherjson = this.otherjson
				this.stuForm.pjson = this.otherjson
				if (!this.taped) {
					this.taped = true
					setTimeout(() => {
						this.taped = false
					}, 3000)
				} else {
					return
				}

				this.$confirm({
					title: '报名提醒',
					message: '确认提交报名信息，提交后不支持修改！',
					theme: 'round-button',
				}).then(() => {
					// on close


					this.$http.post("/api/app_stu_form", this.stuForm).then(res => {

						if (res.data.id) {
							this.stuForm.id = res.data.id
							this.$message.alert({
								title: '提示',
								message: '报名登记成功！',
								theme: 'round-button',
							}).then(() => {

								this.$router.push("/bkinfo?pmid=" + window.pmid + "&openid=" + this
									.openid)
							});
							this.$message.success('登记成功，请耐心等待审核~');
							// this.showBtn = false
							// this.disabled = true
						} else {
							if (res.data.code && res.data.code != 200) {
								this.$message.success(res.data.msg);
							} else {
								this.$message({
									title: '完善信息',
									message: '提交成功，您的信息已提交！',
									theme: 'round-button',
								}).then(() => {
									// on close
								});
							}
						}
					})
				});


			},
		}
	}
</script>
<style type="text/css" scoped="">
	.rowlabel {
		display: inline-block;
		width: 6px;
		border-radius: 3px;
		height: 14px;
		float: left;
		background: #1283ff;
		vertical-align: middle;
		transform: translateY(2px);
		margin-right: 5px;
	}
</style>
